import { init as map } from './map';
import { init as viewSwitcher } from './view-switcher';

viewSwitcher(viewChange);

function viewChange(view) {
	if (view === 'map') {
		map();
	}
}
